import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable()
export class TranslationService {
  constructor(private _apiService: ApiService) {}
  translateLabel(text: string): Observable<string> {
    return this._apiService
      .send('Post', '/api/translate-labels', { text })
      .pipe(map((data: any) => data?.response?.objects?.[0]?.translatedText ?? text));
  }
}
